import React, { useState } from "react";
import styles from "./PreviewEmail.module.scss";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";
import { ErrorMessage, Field, FieldArray, Formik } from "formik";
import { Form } from "react-router-dom";
import * as Yup from "yup";
const PreviewEmail = (props) => {
  const [showIcon, setShowIcon] = useState(
    props?.data?.showInstructions || false
  );
  const [error, setError] = useState(false);
  const [emailFields, setEmailFields] = useState([{ email: "" }]);

  // Handle email input change
  const handleChange = (index, event) => {
    const values = [...emailFields];
    values[index].email = event.target.value;
    setEmailFields(values);
  };

  // Add new email field
  const handleAddField = () => {
    setEmailFields([...emailFields, { email: "" }]);
  };

  // Remove email field
  const handleRemoveField = (index) => {
    const values = [...emailFields];
    values.splice(index, 1);
    setEmailFields(values);
  };
  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setError(!emailRegex.test(value));
  };


  return (
    <div className={styles.mainContainer}>
      <Formik
        initialValues={{ emails: [""] }}
        validationSchema={Yup.object({
          emails: Yup.array()
            .of(
              Yup.string()
                .matches(/^[^@]+@[^@]+\.[^@]+$/, "Invalid email format")  
                .required("Email is required") 
            )
            .min(1, "At least one email is required"),
        })}
        onSubmit={() => { }} // No submit needed
      >
        {({ values, errors, touched }) => (
          <Form>

            <div className={styles.mainContent}>
              {/* Heading with required asterisk and instruction/media icons */}
              <div className={styles.heading}>
                <span>
                  {props?.data?.required && <span style={{ color: "red" }}>*</span>}
                  {props?.data?.value || props?.name || props?.label}
                </span>
                {props?.instructions || props?.data?.media?.length ? (
                  <div>
                    {showIcon ? (
                      <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
                    ) : (
                      <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
                    )}
                  </div>
                ) : null}
              </div>

              {/* Email Input Fields */}
              <FieldArray name="emails">
                {({ push, remove }) => (
                  <div style={{ maxWidth: "400px", position: "relative" }}>
                    {values.emails.map((email, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "10px",
                          gap: "8px",
                        }}
                      >
                        <Field
                          name={`emails.${index}`}
                          type="email"
                          placeholder="Type email"
                          style={{
                            flex: 1,
                            minWidth: "250px",
                            padding: "5px",
                            border:
                              touched.emails?.[index] && errors.emails?.[index]
                                ? "1px solid red"
                                : "1px solid gray",
                            borderRadius: "4px",
                          }}
                        />
                        {/* Remove button only on already added emails */}
                        {values.emails[index] && index !== values.emails.length - 1 && (
                          <button
                            type="button"
                            onClick={() => remove(index)}
                            style={{
                              background: "transparent",
                              border: "none",
                              cursor: "pointer",
                              padding: "5px",
                              display: "flex",
                              alignItems: "center",
                            }}
                            aria-label="Remove email"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="red"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <line x1="18" y1="6" x2="6" y2="18"></line>
                              <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                          </button>
                        )}
                      </div>
                    ))}

                    {/* Add Email Button Floated to Right */}
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                      <button
                        type="button"
                        onClick={() => {
                          const lastIndex = values.emails.length - 1;
                          if (!errors.emails?.[lastIndex] && values.emails[lastIndex]) {
                            push("");
                          }
                        }}
                        style={{
                          background: "#007bff",
                          color: "white",
                          border: "none",
                          padding: "8px 12px",
                          cursor: "pointer",
                          borderRadius: "4px",
                        }}
                      >
                        ➕ Add Email
                      </button>
                    </div>
                  </div>
                )}
              </FieldArray>
            </div>
            {/* </div> */}
          </Form>
        )}
      </Formik>
      {showIcon && (
        <div className={styles.subContent}>
          {props?.instructions && (
            <div className={styles.instructionText}>
              {props?.instructions}
            </div>
          )}
          {props?.data?.media?.length > 0 &&
            props?.data?.media.map((image, index) => (
              <img
                key={index}
                className={styles.imageStyle}
                src={image.path}
                alt="Preview"
              />
            ))}
        </div>
      )}
    </div>
  );
};


export default PreviewEmail;
